import { render, staticRenderFns } from "./QuizTeacherTestOverview.vue?vue&type=template&id=73b680f5&"
import script from "./QuizTeacherTestOverview.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherTestOverview.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherTestOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports